import * as T from '../../../components/Table'

export function Columns() {
  return (
    <T.Thead>
      <T.Tr>
        <T.Th>Data</T.Th>
        <T.Th>Pedido</T.Th>
        <T.Th>Consultor</T.Th>
        <T.Th>Empresa</T.Th>
        <T.Th>Valor</T.Th>
        <T.Th>Cond. Pagamento</T.Th>
        <T.Th>Atraso</T.Th>
      </T.Tr>
    </T.Thead>
  )
}
